import { SubmissionStatus } from '@bp/bp-graphql-types';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { BpLink } from 'components/BpLink/BpLink';
import { StatusChip } from 'components/StatusChip/StatusChip';
import { useDays } from 'hooks/useDays';
import { useRequireParams } from 'hooks/useRequireParams';
import { useTranslation } from 'react-i18next';
import styles from './AssignmentCard.module.scss';

type AssignmentCardStudentProps = {
  assignmentUuid: string;
  onNavigate: (uuid: string) => void;
};

export const AssignmentCardStudent = ({ assignmentUuid, onNavigate }: AssignmentCardStudentProps) => {
  const { t } = useTranslation();
  const { courseUuid } = useRequireParams(['courseUuid']);

  const { daysLeft } = useDays();

  const { assignments } = useAssignments({ courseUuid, assignmentUuid });

  const assignment = assignments.find((a) => a.uuid === assignmentUuid);
  if (!assignment) throw new Error('Assignment not found');

  const { uuid, title, dueDate } = assignment;

  const daysDifference = daysLeft(dueDate.toISOString(), true);

  return (
    <div className={styles['assignment-card']}>
      <div className={styles.top}>
        <div className={styles.count}>
          {daysDifference < 0
            ? t('assignments.overdue')
            : t('dates.daysToGo', {
                count: daysDifference,
              })}
        </div>
      </div>

      <BpLink value={title} onNavigate={() => onNavigate(uuid)} isEditorOfCourse className={styles.link} />

      <div className={styles.bottom}>
        <StatusChip status={assignment.submissions[0]?.status ?? SubmissionStatus.Todo} />
      </div>
    </div>
  );
};
